import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { NamedLink } from '../../components';
import vaarmarktApi from '../../util/vaarmarktApi';

import css from './PopularBrandModelsRail.module.css';

/**
 * Renders a horizontal rail of "Populaire modellen" for a brand on the
 * single-brand SEOPage. Fetches client-side; this is internal-linking
 * enrichment, not primary SEO content.
 */
const PopularBrandModelsRail = ({ brandSlug, brandLabel }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!brandSlug) return undefined;
    let cancelled = false;
    vaarmarktApi
      .get('/seo-pages', {
        params: {
          type: 'brand-model',
          brandSlug,
          isStale: false,
          sortBy: '-aggregates.count',
          perPage: 12,
        },
        useCache: true,
      })
      .then(data => {
        if (!cancelled) setItems(data?.data || []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, [brandSlug]);

  if (!items.length) return null;

  return (
    <section className={css.root} aria-label="Populaire modellen">
      <h2 className={css.heading}>
        <FormattedMessage
          id="SEOPage.popularModels"
          defaultMessage="Populaire {brand} modellen"
          values={{ brand: brandLabel }}
        />
      </h2>
      <ul className={css.list}>
        {items.map(item => (
          <li key={item.slug} className={css.item}>
            <NamedLink
              name="BrandModelPage"
              params={{ brandSlug: item.brandSlug, modelSlug: item.modelSlug }}
            >
              {item.modelLabel}
              {item.aggregates?.count != null ? (
                <span className={css.count}> ({item.aggregates.count})</span>
              ) : null}
            </NamedLink>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default PopularBrandModelsRail;
